import { Provider } from 'api/types';

export const SENTIMENT = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral',
} as const;

export type Sentiment = typeof SENTIMENT[keyof typeof SENTIMENT];

/** Pill-shaped Chip variants for feedback sentiment labels. */
export const SENTIMENT_CHIP_VARIANT = {
  [SENTIMENT.positive]: 'mint',
  [SENTIMENT.negative]: 'ballet',
  [SENTIMENT.neutral]: 'neutral',
} as const;

export const FEEDBACK_TYPE = {
  CANCELLATION: 'user-cancellation',
  VISIT_GOALS: 'visit-goals',
  APPOINTMENT_SATISFACTION: 'appointment-satisfaction',
  NPS: 'nps',
  COMPLAINTS: 'complaints',
  DAILY_NOTE: 'daily-note',
  GOAL_BLOCK_FEEDBACK: 'goal-block-feedback',
  GENERAL_EMOJI_SENTIMENT: 'general-emoji-sentiment',
  CARE_GUIDE_SETUP: 'care-guide-setup',
  CAREOS_BLOCK_FEEDBACK: 'careos-block-feedback',
  CHIEF_COMPLAINT_FEEDBACK: 'chief-complaint-feedback',
};

export const FEEDBACK_OPTIONS = {
  majorImprovement: 'Major improvement',
  noticeableImprovement: 'Noticeable improvement',
  noChange: 'No change',
  worsening: 'Worsening',
  successful: 'Successful',
  challenges: 'Challenges',
  helping: 'Helping',
  notHelping: 'Not helping',
} as const;

export type FeedbackOption =
  typeof FEEDBACK_OPTIONS[keyof typeof FEEDBACK_OPTIONS];

export const FEEDBACK_OPTION_SENTIMENT = {
  [FEEDBACK_OPTIONS.majorImprovement]: SENTIMENT.positive,
  [FEEDBACK_OPTIONS.noticeableImprovement]: SENTIMENT.positive,
  [FEEDBACK_OPTIONS.noChange]: SENTIMENT.negative,
  [FEEDBACK_OPTIONS.worsening]: SENTIMENT.negative,
  [FEEDBACK_OPTIONS.successful]: SENTIMENT.positive,
  [FEEDBACK_OPTIONS.challenges]: SENTIMENT.negative,
  [FEEDBACK_OPTIONS.helping]: SENTIMENT.positive,
  [FEEDBACK_OPTIONS.notHelping]: SENTIMENT.negative,
} as const;

export type FeedbackType = typeof FEEDBACK_TYPE[keyof typeof FEEDBACK_TYPE];

export type UserFeedbackSurvey = {
  id: string;
  survey_type: FeedbackType | null;
  survey: Record<string, any>;
  created_at: string;
  feedback_day: string | null;
  user_block_id: string | null;
  provider: Provider | null;
  healthie_id: number | null;
};

export const symptomsFeedbackOptions = [
  FEEDBACK_OPTIONS.majorImprovement,
  FEEDBACK_OPTIONS.noticeableImprovement,
  FEEDBACK_OPTIONS.noChange,
  FEEDBACK_OPTIONS.worsening,
];

export const implementationFeedbackOptions = [
  FEEDBACK_OPTIONS.successful,
  FEEDBACK_OPTIONS.challenges,
];

export const sentimentFeedbackOptions = [
  FEEDBACK_OPTIONS.helping,
  FEEDBACK_OPTIONS.notHelping,
];
